<template>
    <div
        class="mobile-nav-bar"
    >
        <a
            v-for="{id, label, icon, toast} in model.buttons"
            :key="id"
            class="dha-link menu-button"
            href="javascript:void(0);"
            :class="{
                selected: model.selected === id
            }"
            @click="() => {
                if (model.selected === id) {
                    model.selected = null;
                    enableBodyScroll();
                } else {
                    model.selected = id;
                }
            }"
        >
            <span class="label">{{ label }}</span>
            <svg-inline
                v-if="icon"
                :class="`${icon}-icon`"
                :src="`${icon}_icon`"
            />
            <div :class="`toast ${toast ? 'show' : ''}`">
                {{ toast }}
            </div>
        </a>
    </div>
</template>

<script>
import SvgInline from '@/components/SvgInline.vue';
import MobileNavModel from '@/model/MobileNavModel';

export default {
    components: {
        SvgInline
    },
    props: {
        model: {
            type: MobileNavModel,
            required: true
        },
    },
    data() {
        return {
        };
    },
    computed: {
    },
    methods: {
        enableBodyScroll() {
            document.body.style.overflowY = 'scroll';
        }
    }
};
</script>

<style lang="postcss" scoped>
.mobile-nav-bar {
    @apply flex flex-row h-full;
    width: 120px;
    min-width: 110px;
    justify-content: space-between;
}
.label {
    @apply text-neutral-text font-normal whitespace-no-wrap text-2xs;
}

.dha-link {
    @apply
        flex flex-row justify-center items-center
        text-neutral-3
        text-sm
        select-none
        border-b-4
        border-transparent;
    text-decoration: none !important;
}

.dha-link i {
    @apply
        font-bold
        ml-2;
    font-size: 24px !important;
}

.dha-link.selected {
    @apply border-solid border-neutral-4;
}

.search-icon >>> svg {
    @apply my-auto;
    height: 12px;
    width: 12px;
    margin-left: 5px;
    fill: none;
    stroke: currentColor;
    stroke-width: 3px;
}
</style>
